'use strict';

// Base64 polyfill
import Base64 from 'Base64';
import store from 'store';
import api from 'utils/api';
import dom from 'utils/dom';
import Immutable from 'immutable';
import { assign } from 'lodash';
import flux from 'utils/flux';

const AppSource = (alt) => {
    return {
        loginUser: {
            remote( state, user ) {
                return api.post('login', user);
            },
            success: alt.getActions('app').loginUserSuccess,
            error: alt.getActions('app').onError
        },
        logoutUser: {
            remote( state, user ) {
                const token = store.get('mediabox_token');
                return api.post('logout', { token });
            },
            success: alt.getActions('app').logoutUserSuccess,
            error: alt.getActions('app').onError
        },
        acceptTerms: {
            remote( state, data ) {
                return api.post('user_data', data);
            },
            success: alt.getActions('app').acceptTermsSuccess,
            error: alt.getActions('app').onError
        },
        registerUser: {
            remote( state, data ) {
                return api.post('register', data);
            },
            success: alt.getActions('app').registerUserSuccess,
            error: alt.getActions('app').onError
        },
        resetPassword: {
            remote( state, data ) {
                return api.post('reset_password', data);
            },
            success: alt.getActions('app').resetPasswordSuccess,
            error: alt.getActions('app').onError
        },
        updatePassword: {
            remote( state, data ) {
                return api.post('change_password', data);
            },
            success: alt.getActions('app').updatePasswordSuccess,
            error: alt.getActions('app').onError
        },
        confirmEmail: {
            remote( state, data ) {
                return api.post('confirm_email', data);
            },
            success: alt.getActions('app').confirmEmailSuccess,
            error: alt.getActions('app').onError
        },
        loadAccountData: {
            remote() {
                return api.get('user_data');
            },
            success: alt.getActions('app').loadAccountDataSuccess,
            error: alt.getActions('app').onError
        },
        updateAccountData: {
            remote(state, data) {
                return api.post('edit_user', data).then(() => {
                    return api.get('user_data').then(alt.getActions('app').loadAccountDataSuccess);
                });
            },
            success: alt.getActions('app').noop,
            error: alt.getActions('app').onError
        },
        loadTerms: {
            local(state) {
                return state.terms;
            },
            remote() {
                return api.getHtml('terms-of-use');
            },
            success: alt.getActions('app').loadTermsSuccess,
            error: alt.getActions('app').onError
        }
    };
};

export default class AppStore {

    constructor() {
        this.bindActions(this.alt.getActions('app'));
        this.registerAsync(AppSource);
        this.exportPublicMethods({
            logout: this.onLogout
        });

        this.termsAccepted    = store.get('mediabox_terms_accepted');
        this.token            = store.get('mediabox_token');
        this.user             = store.get('mediabox_user');
        this.accountEditable  = store.get('mediabox_account_editable');
        this.passwordEditable = store.get('mediabox_password_editable');
        this.hideFilters = store.get('mediabox_hideFilters');
        
        if ( this.token ) {
            api.registerToken( this.token );
        }

        const buildConfig = ( 'production' === process.env.NODE_ENV && require('../config') ) || {};
        this.config = Immutable.fromJS( assign( {}, window.config, buildConfig ) );

        this.error = false;
        this.accountData = false;
        this.terms = null;
    }

    onError(err) {
        err = JSON.parse(err.response);
        this.error = err.message;
    }

    onClearError() {
        this.error = null;
    }

    onAcceptTermsSuccess( data ) {
        store.set( 'mediabox_terms_accepted', true );
        this.termsAccepted = true;
    }

    onLoginUserSuccess( data ) {
        const { access_token, full_name, account_editable, password_editable, termsAccepted, hideFilters } = data;

        store.set( 'mediabox_terms_accepted', termsAccepted );
        store.set( 'mediabox_token', access_token );
        store.set( 'mediabox_user', full_name );
        store.set( 'mediabox_account_editable', account_editable );
        store.set( 'mediabox_password_editable', password_editable );
        store.set( 'mediabox_hideFilters', hideFilters);
        store.set( '_CSRF', data._CSRF );

        this.termsAccepted    = termsAccepted;
        this.token            = access_token;
        this.user             = full_name;
        this.accountEditable  = account_editable;
        this.passwordEditable = password_editable;
        this.hideFilters = hideFilters;
        this.error            = false;

        api.registerToken( this.token );
    }

    onLoadAccountDataSuccess(data) {
        this.error = false;
        this.accountData = data;
    }

    noop() {
    }

    onLoadTermsSuccess(terms) {
        this.terms = terms;
    }

    onLogout() {
        flux.getStore('app').logoutUser();
    }

    onLogoutUserSuccess() {
        this.token = null;
        this.user  = null;

        api.removeToken();
        store.clear();

        // empty caches
        flux.getStore('media').state._cache = {};

        window.location = `${location.protocol}//${location.host}`;
    }

    static toggleOffcanvas() {
        var bodyEl = document.getElementsByTagName('body')[0];
        dom.toggleClass(bodyEl, 'offcanvas--active');
    }

    static closeOffcanvas() {
        var bodyEl = document.getElementsByTagName('body')[0];
        dom.removeClass(bodyEl, 'offcanvas--active');
    }

    static isAuthenticated() {
        var {token} = this.getState();
        if (!token) {
            return false;
        }
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        var exp = JSON.parse(window.atob(base64)).exp;
        var isValid = Math.round(new Date().getTime() / 1000) <= exp;

        if (!isValid) {
            this.logout();
        }

        return isValid;
    }

    static hasAcceptedLatestTerms() {
        var {termsAccepted} = this.getState();
        return termsAccepted;
    }
}



// WEBPACK FOOTER //
// ./app/stores/appStore.js